import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Keyboard from 'simple-keyboard';
import { parseProps, numericKeyboardOptions, keyboardOptions, numericZipKeyboardOptions, keyboardAccountOptions, keyboardOptionsXL, alphaNumeric, keyboardOptionsLocker, numericLocker, keyboardPlanTools, keyboardPlanToolsWithSubmit, keyboardPlanToolsWithSubmitAndTab } from './Utilities';

class KeyboardReact extends Component {
    state = { input: '', shiftCount: 0 }
    baseClassDefault = "react-simple-keyboard";
    baseClassShift = "react-simple-keyboard allupper";

    componentDidMount = () => this.initKeyboard();

    clearInput = inputName => {
        this.setState({ input: '' });
        this.keyboard.clearInput(inputName || 'default');
    }

    getInput = inputName => inputName ? this.keyboard.input[inputName] : this.state.input;

    setInput = (input, inputName) => new Promise(resolve => {
        if (window.keyboardDebug) {
            //console.log('input value from setInput function: ', input);
        }
        this.keyboard.setInput(input, inputName);
        this.setState({ input }, () => {
            resolve(input);
            if (window.keyboardDebug) {
                //console.log('input value from setInput function after setState: ', input);
            }
        });
    })

    onKeyPress = button => {
        const { shiftCount } = this.state;
        if (window.keyboardDebug) {
            console.log('keyboard button pressed: ', button);
        }
        if (button.includes('disable')) {
            return false;
        }
        if (button === '{shiftleft}') {
            this.setState({
                shiftCount: shiftCount > 1 ? 0 : shiftCount + 1
            })
        }
        if (shiftCount !== 2 && button !== '{shiftleft}') {
            this.setState({
                shiftCount: 0
            })
        }
        // console.log('====> shiftCount 2', shiftCount)
        // if ((button === '{shiftleft}' && shiftCount === 2) || (button.includes("{") && button.includes("}") && button !== '{shiftleft}')) {
        //   this.setState({
        //     shiftCount: 0
        //   })
        // }
        if (button === 'Clear') {
            //console.log('Clear clicked');
            this.setInput('');
            //console.log('input after clear', this.state.input);
        }
        this.handleLayoutChange(button);
        const { onKeyPress } = this.props;
        if (typeof onKeyPress === "function")
            onKeyPress(button);

    }
    handleLayoutChange = (button) => {
        const { debug } = this.props;
        const { shiftCount } = this.state;
        let currentLayout = this.keyboard.options.layoutName;
        let _layoutName;
        switch (button) {
            case "{shiftleft}":
                _layoutName = (currentLayout === "default") ? "shift" : "default";
                if (shiftCount === 1) {
                    _layoutName = "shift";
                }
                break;
            case "{default}":
                _layoutName = currentLayout === "default" ? "shift" : "default";
                break;

            case "{splchars}":
                _layoutName = currentLayout === "splchars" ? "default" : "splchars";
                break;

            case "&123":
                _layoutName = currentLayout === "splchars" ? "default" : "splchars";
                break;

            case "{abc}":
                _layoutName = "default";
                break;

            default:
                _layoutName = "default"
                if (currentLayout === "splchars") {
                    _layoutName = "splchars"
                }
                if (currentLayout === "shift" && shiftCount >= 2) {
                    _layoutName = "shift"
                }
                break;
        }

        if (debug) {
            //console.log("Key pressed:", button);
        }
        //console.log("Key pressed:", button);
        if (_layoutName) {
            this.keyboard.setOptions({
                layoutName: _layoutName
            });
        }

    }

    onChange = input => {
        const { keyboard, props: { debug, onChange, onChangeAll }, state } = this;

        this.setState({ input }, () => {
            if (debug) {
                //console.log('Input changed:', state.input);
            }

            /**
             * Calling user onChange
             */
            if (typeof onChange === "function")
                onChange(this.state.input);

            /**
             * Calling user onChangeAll
             */
            if (typeof onChangeAll === "function")
                onChangeAll(keyboard.input);
        });
    }

    initKeyboard = () => {
        const { onKeyPress, onChange, props, getCssBaseClass } = this;
        const {  stopMouseDownPropagation, stopMouseUpPropagation, layout, ...otherProps } = props;
        let cssClass = getCssBaseClass();
        let layoutName = keyboardOptions.layout;
        switch (otherProps.theme) {
            case 'numeric':
                layoutName = numericKeyboardOptions.layout;
                break;
            case 'zipcode':
                layoutName = numericZipKeyboardOptions.layout;
                break;
            case 'accountnumber':
                layoutName = keyboardAccountOptions.layout;
                break;
            case 'alphanumeric':
                layoutName = alphaNumeric.layout;
                break;
            case 'xl':
                layoutName = keyboardOptionsXL.layout;
                break;
            case 'plantools':
                layoutName = otherProps.planToolsWithSubmit ? keyboardPlanToolsWithSubmit.layout : otherProps.planToolsWithSubmitAndTab ? keyboardPlanToolsWithSubmitAndTab.layout : keyboardPlanTools.layout;
                break;
            case 'plantoolsWithSubmit':
                layoutName = keyboardPlanToolsWithSubmit.layout;
            case 'locker':
                layoutName = keyboardOptionsLocker.layout;
                break;
            case 'numericLocker':
                layoutName = numericLocker.layout;
                break;
            default:
                break;
        }
        let colorTheme = 'darkTheme';
        if (props.keyboardColorTheme) {//overriding container theme with keyboard theme //keyboardColorTheme prop- added for locker
            colorTheme = props.keyboardColorTheme === 'dark' ? 'darkTheme' : 'lightTheme';
        }
        this.keyboard = new Keyboard(`.${cssClass}`, {
            ...parseProps({ ...otherProps, colorTheme }),
            onKeyPress,
            onChange,
            stopMouseUpPropagation,
            stopMouseDownPropagation,
            layout: layoutName,
            mergeDisplay: true,
            buttonAttributes: [
                {
                    attribute: "role",
                    value: "button",
                    buttons: "1 2 3 4 5 6 7 8 9 0 Clear {backspace}"
                },
                {
                    attribute: "tabIndex",
                    value: `${props.initialTabIndex}`,
                    buttons: "1 2 3 4 5 6 7 8 9 0"
                },
                {
                    attribute: "tabIndex",
                    value: `${props.initialTabIndex + 1}`,
                    buttons: "{backspace}"
                },
                {
                    attribute: "tabIndex",
                    value: `${props.initialTabIndex + 2}`,
                    buttons: "Clear"
                },
            ],
            useButtonTag: window.isLocker || false,
            useMouseEvents: window.isLocker || false,
        });
    }

    getCssBaseClass = () => {
        return this.props.baseClass || this.baseClassDefault
    };

    render() {
        const { getCssBaseClass } = this;
        const { shiftCount } = this.state;
        let shiftclass = ''

        // if (shiftCount === 2) {
        //   shiftclass = ' allupper';
        // }

        return <div className={`${getCssBaseClass()} ${shiftclass}`}></div>;
    }
}

KeyboardReact.propTypes = {
    layoutName: PropTypes.string,
    layout: PropTypes.object,
    theme: PropTypes.string,
    display: PropTypes.object,
    onChange: PropTypes.func,
    onChangeAll: PropTypes.func,
    onKeyPress: PropTypes.func,
    debug: PropTypes.bool,
    baseClass: PropTypes.string,
    planToolsWithSubmit: PropTypes.bool,
    planToolsWithSubmitAndTab: PropTypes.bool,
    initialTabIndex: PropTypes.number,
    stopMouseDownPropagation: PropTypes.bool,
    stopMouseUpPropagation: PropTypes.bool,
};
KeyboardReact.defaultProps = {
    layoutName: 'default',
    display: keyboardOptions.display,
    initialTabIndex: 0,
}


export default KeyboardReact;
